export default __webpack_public_path__ + "static/media/color-06.11a387b7.svg";